export const isMobile = (breakpoint = 576) => {
  const mobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
  if (mobileDevice) return true

  return window.innerWidth < breakpoint
}

export default isMobile
